import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-cards";
import "./styles.css";
import images from "../../gallery/images";

export default function DefaultSwiper() {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className="test-slider section slider-section">
      <div className="container slider-column">
        <Swiper
          className="swiper-slider"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          loop
          modules={[Pagination]}
          onSlideChange={(swiper: any) => setActiveIndex(swiper.realIndex)}
          breakpoints={
            {
              // 640: { slidesPerView: 1.25, spaceBetween: 20 },
              // 1024: { slidesPerView: 2, spaceBetween: 20 },
            }
          }
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <img src={src} alt={`Slide ${index}`} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="gallery-dots" style={{ marginTop: "1rem" }}>
        {images.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === activeIndex ? "active" : ""}`}
          />
        ))}
      </div>
    </section>
  );
}
